import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">精选策划专题，深度发现好内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:scale-[1.01] transition-transform duration-300"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-white">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}